import React from 'react';
import Papa from 'papaparse'

export default class Login extends React.Component {

    constructor() {
        super();
        this.state = {
            formData : {},
            userList: [],
            invalid: false
        }
    }
    componentDidMount() {
        this.getUsersList();
    }

    getUsersList() {
        // https://docs.google.com/spreadsheets/d/1uJASzNfN-aiu3GFnPAggI9YCrtT4_NxNtgAs-6U52E4/edit?gid=737256463#gid=737256463
        // https://docs.google.com/spreadsheets/d/19v2WbZtUApzDHlE-fkjPPe5RJ9tVUzSfF0EmhAh8-pQ/edit?gid=144389730#gid=144389730
        // Papa.parse("https://docs.google.com/spreadsheets/d/19v2WbZtUApzDHlE-fkjPPe5RJ9tVUzSfF0EmhAh8-pQ/pub?gid=144389730&output=csv", {
        // https://docs.google.com/spreadsheets/d/e/2PACX-1vTYjadxRoBLUCTfbnpQDaj20QqOJdlBQqvoHpK6t-2zkjthvRmF_PDVFxt4R6yCk4Ri-sPCn3BtuWag/pubhtml
        
        Papa.parse("https://docs.google.com/spreadsheets/d/1uJASzNfN-aiu3GFnPAggI9YCrtT4_NxNtgAs-6U52E4/export?format=csv&gid=737256463", {
            download: true,
            header: true,
            complete: (res) => {
                // let result = this.mapLanguages(this.state.userLanguage, res.data);
                this.setState({ userList: res.data });
            },
        });
    }

    handleChange(event, obj){
        let form = this.state.formData;
        form[event.target.name] = event.target.value;
        this.setState({
            formData : form
        },()=>{console.log(this.state.formData)});
    }

    onSubmit() {
        const user = this.state.userList.find(user => user.user === this.state.formData.user && user.password === this.state.formData.password);
        if(user){
            sessionStorage.setItem("userLogged", JSON.stringify(user));
            this.props.history.push('/visitorpass');
        }else{
            this.setState({invalid: true});
        }
    }

    render() {
        return (
            <div className="limiter">
                <div className="container h-vh pl-0 pr-0">
                    <div className="col-md-7 pl-0 pr-0">
                        <div className="pass-container">
                            <div className="logo-container text-center mt-2 mb-4"><img src={require('../assets/images/logo_white.svg')} alt="" /></div>
                            <div className="login100-form validate-form">
                                {this.state.invalid && <div className='text-center'>
                                    <span style={{background: '#dc3545', padding: '5px 10px', borderRadius: '5px'}}>Invalid Username or Password</span>
                                </div>}
                                <div className="form-group" style={{ marginTop: '20px' }}>
                                    <label>Username <span>*</span></label>
                                    <div>
                                        <input type="text" className="form-control text-uppercase" placeholder='Username'
                                            name="user" value={this.state.formData['user']} onChange={(e) => { this.handleChange(e) }} required></input>
                                        {this.state.formData.user == "" && <div style={{ color: 'white' }}>
                                            <div> Username is required </div>
                                        </div>}
                                    </div>
                                </div>
                                <div className="form-group" style={{ marginTop: '20px' }}>
                                    <label>Password <span>*</span></label>
                                    <div>
                                        <input type="password" className="form-control text-uppercase" placeholder='Password'
                                            name="password" value={this.state.formData['password']} onChange={(e) => { this.handleChange(e) }} required></input>
                                        {this.state.formData.password == "" && <div style={{ color: 'white' }}>
                                            <div> Password is required </div>
                                        </div>}
                                    </div>
                                </div>
                                <div>
                                    <button type="button" className="btn btn-primary text-uppercase" disabled={this.state.formData.user == null || this.state.formData.password == '' || !this.state.userList.length} onClick={() => { this.onSubmit() }}>Login</button>
                                </div>
                            </div>
                            <div className="copyright mt-5 text-center text-uppercase"><a href="https://blinkay.com/">© Blinkay</a> {(new Date().getFullYear())}. All Rights Reserved</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}